<template>
<b-navbar type="dark">
  <b-navbar-brand href="/" class="font-weight-bold">PETRA</b-navbar-brand>
  <b-navbar-nav>
    <b-nav-item v-if="isAdmin">
      <router-link to="/validationCycles">Validation Cycles</router-link>
    </b-nav-item>
    <b-nav-item v-if="isAdmin">
      <router-link to="/rps">Responsible Parties</router-link>
    </b-nav-item>
    <!--<b-nav-item>
      <router-link to="/ingestionSites">Ingestion Sites</router-link>
    </b-nav-item>-->
    <b-nav-item>
      <router-link to="/ccds">CCDs</router-link>
    </b-nav-item>
    <b-nav-item>
      <router-link to="/case/list">Review Cases</router-link>
    </b-nav-item>
  </b-navbar-nav>
  <b-navbar-nav v-if="false" class="ml-auto">
    <b-nav-item-dropdown right>
      <!-- Using 'button-content' slot -->
      <template v-slot:button-content>
        <em>User</em>
      </template>
      <b-dropdown-item href="#">Profile</b-dropdown-item>
      <b-dropdown-item href="#">Sign Out</b-dropdown-item>
    </b-nav-item-dropdown>
  </b-navbar-nav>
</b-navbar>
</template>
<script>
export default {
  name: "",
  data: () => ({

  }),
  computed: {
    isAdmin () {
      return this.$store.getters.isAdmin
    }
  }
}
</script>
<style lang="css" scoped>
.nav-link a {
  color: white;
}
.navbar, a {
  background-color: #150957 !important;

}

#nav {
  padding: 30px;

}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
